(ns frontend.test.richtext
  (:require
   [frontend.routing :as routing]
   [basic-components.field-editor :as field-editor]
   [reagent.core :as r]))

(defmethod routing/render-view :test/richtext
  [{:keys [route-params]}]
  (let [state (r/atom {})]
    (fn []
      (let []
        [:div.container.bg-white.py-4.scroll
         [:h1.title-h1.mb-4 "Richtext input-field"]
         [:h2.title-h2.mb-4 "Richtext input-field"]
         [:span
          "The Rich Text Editor (RTE) field enables users to input different types of content such as text, image, videos, and so on"]
         [:div.mt-3
          [field-editor/view
           {:editor/type         :editor.type/wysiwyg
            :value               (:value @state)
            :state-atom          state
            :attribute           :test-richtext-attribute
            :label               "richtext input-field"
            :hide-label?         false
            :on-save!            (fn [e v]
                                   (swap! state assoc :value v))
            :class-name          "richtext__wrapper"
            :show-tooltip-right? true
            :field/tooltip-right "Vivamus sagittis lacus vel augue laoreet rutrum faucibus."
            :mandatory?          false
            :drag-options        nil
            :validate!           (fn [])
            :disabled?           false
            :read-only?          false
            :info-text           "Info Wysiwyg"
            :error-text          "Test error text"
            :tools               [:tool-item/clear
                                  :tool-item/copy
                                  :tool-item/save
                                  :tool-item/cancel]
            :secondary-view-args nil}]]
        ]))))
